// Toggle the staging prototype here. Production always uses the existing navbar.
export const MOBILE_TAB_BAR_PROTOTYPE_ENABLED = true;

/**
 * Keeping the environment guard here prevents the prototype from being enabled
 * in production even when the code toggle above is on.
 */
export const isMobileTabBarPrototypeEnabled = () => true;
